import { Link } from "react-router-dom";
import gnb_01 from "../images/gnb_01.png";
import gnb_02 from "../images/gnb_02.png";
import gnb_03 from "../images/gnb_03.png";
import gnb_04 from "../images/gnb_04.png";
import gnb_05 from "../images/gnb_05.png";
import gnb_06 from "../images/gnb_06.png";
import gnb_01_white from "../images/gnb_01_white.png";
import gnb_02_white from "../images/gnb_02_white.png";
import gnb_03_white from "../images/gnb_03_white.png";
import gnb_04_white from "../images/gnb_04_white.png";
import gnb_05_white from "../images/gnb_05_white.png";
import gnb_06_white from "../images/gnb_06_white.png";
import readyImg from "../images/ready-img.png";
import { useEffect, useState } from "react";
import { useAppContext } from "utils/store";
import { UserAuthorityChoice } from "utils/common";
import { API_HOST } from "Constants";
import { apiWrapper } from "apis/CommonApi";
import * as accountApi from "apis/AccountApi";

export default function Header() {
  const { store: { id, userAuthority } } = useAppContext();
  const [isReadyModalVisible, setReadyModalVisible] = useState(false);
  const [profileImageSrc, setProfileImageSrc] = useState("");

  useEffect(() => {
    apiWrapper(async () => {
      const { status, data } = await accountApi.getUser(id);
      if (status === true) {
        setProfileImageSrc(data.profileImage);
      }
    });
  }, []);

  const showReadyModal = () => {
    setReadyModalVisible(true);
  }

  const closeReadyModal = () => {
    setReadyModalVisible(false);
  }

  return (
    <>
      <nav class="wrap_header">
        <div class="container">
          <div class="wrap_logo">
            {profileImageSrc && (
              <img src={API_HOST + profileImageSrc} />
            )}
          </div>
          <div class="menu_gnb">
            <MenuItem
              onClick={showReadyModal}
              title={<>시스템 소개<br />(사용 매뉴얼)</>}
              itemName="item_gnb_01"
              defaultSrc={gnb_01}
              blackSrc={gnb_01_white}
            />
            <MenuItem
              onClick={showReadyModal}
              title="시스템 문의"
              itemName="item_gnb_03"
              defaultSrc={gnb_03}
              blackSrc={gnb_03_white}
            />
            <MenuItem
              onClick={showReadyModal}
              title={<>소방시설공사<br />견적문의</>}
              itemName="item_gnb_04"
              defaultSrc={gnb_04}
              blackSrc={gnb_04_white}
            />
            <MenuItem
              onClick={showReadyModal}
              title={<>소방시설점검<br />견적문의</>}
              itemName="item_gnb_05"
              defaultSrc={gnb_05}
              blackSrc={gnb_05_white}
            />
            {(userAuthority === UserAuthorityChoice.ADMIN || userAuthority === UserAuthorityChoice.BUSINESS) && (
              <MenuItem
                linkTo="/dbms/fire-receiver/management/"
                title="시스템 DBMS"
                itemName="item_gnb_06"
                defaultSrc={gnb_06}
                blackSrc={gnb_06_white}
              />
            )}
          </div>
        </div>
      </nav>
      {isReadyModalVisible && <ReadyModal closeReadyModal={closeReadyModal} />}
    </>
  );
}

const MenuItem = ({ linkTo, onClick, title, itemName, defaultSrc, blackSrc }) => {
  const header = document.getElementById('header');
  const isBlack = header?.classList.contains('black');

  return (
    <Link className={`item_gnb ${itemName}`} to={linkTo} onClick={onClick} >
      <img
        className={`img_gnb ${isBlack ? 'black-image' : 'default-image'}`}
        src={isBlack ? blackSrc : defaultSrc}
        alt={title}
        data-default-src={defaultSrc}
        data-black-src={blackSrc}
      />
      <p class="title_gnb">{title}</p>
    </Link >
  );
};

const ReadyModal = ({ closeReadyModal }) => (
  <div class="modal-overlay ready-modal" id="readyModal" style={{ display: 'flex' }}>
    <div class="modal-content ready-modal-content">
      <button class="modal-close-btn" onClick={closeReadyModal}>
        <i class="x-icon"></i></button>
      <img src={readyImg} alt="준비중 이미지" class="ready-img" />
      <p class="ready-title">현재 페이지는<br />준비중입니다.</p>
      <p class="ready-subtext">
        현재 페이지는 더욱 좋은 모습을 선보이기 위해 준비 중입니다. <br />
        빠른 시일 내에 업데이트하여 찾아뵙겠습니다.
      </p>
    </div>
  </div>
);